import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/** color-mix tint of a token, e.g. 'var(--tint)'. */
export function mix(color: string, percent: number): string {
    return `color-mix(in srgb, ${color} ${percent}%, transparent)`
}

/** Portuguese plural: plural(2, 'pausado', 'pausados') → "pausados". */
export function plural(n: number, one: string, many: string): string {
    return n === 1 ? one : many
}
